import React from 'react';
import { useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, IconButton, Paper, TableContainer, Table, TableHead, TableRow, TableBody, Tooltip, CircularProgress, MenuItem, TextField } from '@material-ui/core';
import { StyledTableCell, StyledTableCellHead, StyledTableRow } from '../../atoms/table/tableStyles';
import DeleteIcon from '@material-ui/icons/Delete';
import RemoveMemberAlert from '../alerts/RemoveMemberAlert';
import { useForm, Controller } from "react-hook-form";
import { handleSnackBar } from "../../../store/global/actions";
import { invokePostService } from '../../../store/global/actions'

const useStyles = makeStyles((theme) => ({
    accessLevelBtn: {
        '& .MuiSelect-root': {
            fontWeight: 'normal'
        }
    }

}));

const SharedMembersTable = (props) => {
    const { sharedMembers, getSharedList, isAdminUser, isPrimaryUser } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, control, watch } = useForm();
    const [memberToRemove, setMemberToRemove] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isUpdating, setIsUpdating] = useState(false);

    const accessLevels = { ADMIN: 'Admin', VIEWER: 'Viewer', EDITOR: 'Editor', OWNER: 'Owner' };
    const accessLevelsList = [{ title: 'Admin', value: 'ADMIN' }, { title: 'Viewer', value: 'VIEWER' }, { title: 'Editor', value: 'EDITOR' }];

    const onRemoveCompletion = () => {
        setMemberToRemove(null);
        getSharedList();
    }

    const onUpdateAccessLevel = (member, accessLevel, index) => {
        setSelectedRow(index);
        setIsUpdating(true);
        dispatch(invokePostService('updateMember', {accessLevel}, [member._id])).then(res => {
            setIsUpdating(false);
            setSelectedRow(null);
            getSharedList();
            if (res?.status == true) {
                dispatch(handleSnackBar({ open: true, message: 'Access level updated', severity: "success" }));
            } 
        });
    }


    return (
        <Grid container direction="row" spacing={2}>
            <Grid item xs={12} style={{ height: 'auto', overflow: 'auto', width: '600px' }}>
                {<TableContainer component={Paper} style={{borderRadius: 0, boxShadow: 'none'}} >

                    <Table id='shared_members_table'>
                        <TableHead>
                            <TableRow>
                                <StyledTableCellHead align='left' style={{ width: 30 }}>Name</StyledTableCellHead>
                                <StyledTableCellHead align='left' style={{ width: 30 }}>Username</StyledTableCellHead>
                                <StyledTableCellHead align='left' style={{ width: 30 }}>Access Level</StyledTableCellHead>
                                {(isAdminUser || isPrimaryUser) && <StyledTableCellHead align='right' style={{ width: 60 }}>Action</StyledTableCellHead>}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {sharedMembers === undefined || sharedMembers == null ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={5} component="td" style={{ padding: 15 }}>
                                        Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                    </StyledTableCell>
                                </StyledTableRow>
                                : sharedMembers.length < 1 ?
                                    <StyledTableRow>
                                        <StyledTableCell align={'center'} colSpan={6} component="td" style={{ padding: 15 }}>
                                            No members available.
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    : sharedMembers.map((item, index) => (
                                        <StyledTableRow key={index + 1}>
                                            <StyledTableCell align={'left'} component="td" style={{ width: 30 }}>
                                                {`${item?.userId.firstName} ${item?.userId.lastName}`}
                                            </StyledTableCell>

                                            <StyledTableCell align={'left'} component="td" style={{ width: 30 }}>
                                                {item?.userId.username}
                                            </StyledTableCell>

                                            <StyledTableCell align={'left'} component="td" style={{ width: 60 }}>
                                                {(item.access_level === 'OWNER' ? true : !isPrimaryUser && !isAdminUser ? true : ( !isPrimaryUser && isAdminUser && item.access_level === 'ADMIN') ? true : false) ?
                                                    accessLevels[item.access_level]
                                                    :
                                                    <Controller
                                                        name="accessLevel"
                                                        control={control}
                                                        defaultValue={item.access_level}
                                                        rules={{ required: true }}
                                                        render={({ field, value, onChange }) =>
                                                            <>
                                                                <TextField
                                                                    {...field}
                                                                    name="accessLevel"
                                                                    // label={'Access level'}
                                                                    select
                                                                    size={'small'}
                                                                    disabled={isUpdating}
                                                                    value={value}
                                                                    className={classes.accessLevelBtn}
                                                                    onChange={e => { onChange(e); onUpdateAccessLevel(item, e.target.value, index) }}
                                                                >
                                                                    {accessLevelsList.map((option) => (
                                                                        <MenuItem key={option.value} value={option.value}>
                                                                            {option.title}
                                                                        </MenuItem>
                                                                    ))}
                                                                </TextField>
                                                                {(isUpdating && selectedRow == index) && <CircularProgress size={12} style={{ color: '#000', marginLeft: 5 }} />}
                                                            </>
                                                        }
                                                    />
                                                }
                                            </StyledTableCell>
                                            {(isAdminUser || isPrimaryUser) &&
                                                <StyledTableCell align={'right'} component="td" style={{ width: 30 }}>
                                                    {!(item.access_level === 'OWNER' || (!isPrimaryUser && isAdminUser && item.access_level === 'ADMIN')) &&
                                                        <Tooltip title="Remove member" id='remove_member'>
                                                            <IconButton color="secondary" aria-label="Remove member" component="span">
                                                                <DeleteIcon onClick={() => setMemberToRemove(item)} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                </StyledTableCell>
                                            }

                                        </StyledTableRow>

                                    ))}
                        </TableBody>
                    </Table>
                </TableContainer>}
            </Grid>

            {memberToRemove !== null && <RemoveMemberAlert memberToRemove={memberToRemove} onCompletion={onRemoveCompletion} onClose={() => setMemberToRemove(null)} />}
        </Grid>
    )

}

export default SharedMembersTable
